import { render } from "./PerformanceReportPage.vue?vue&type=template&id=19e5c5dc&scoped=true"
import script from "./PerformanceReportPage.vue?vue&type=script&lang=js"
export * from "./PerformanceReportPage.vue?vue&type=script&lang=js"

import "./PerformanceReportPage.vue?vue&type=style&index=0&id=19e5c5dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19e5c5dc"]])

export default __exports__